<template>
  <HeaderTitle single back-target="settings">
    <template #bottom>{{ t("profile.about.dataprivacy.item.title") }}</template>
  </HeaderTitle>
  <BasicWrapper white>
    <legal-text
      v-if="!isLoading"
      :text="clientStore.getDataPrivacy ?? $('data.privacy')"
      is-data-privacy
    ></legal-text>
    <div class="flex justify-center flex-row items-center mt-4">
      <button class="button-bkk-100 mt-4" @click="cookieConsentOpen = true">
        {{ $t("cookie.consent.customize.settings") }}
      </button>
      <CookieConsent
        v-if="cookieConsentOpen"
        force-open="true"
        @on-save-settings="cookieConsentOpen = false"
      />
    </div>
  </BasicWrapper>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useClientStore } from "../../store/v2/client";
import CookieConsent from "../../components/v2/layout/CookieConsent.vue";
import LegalText from "../../components/v2/legal/legalText.vue";
import BasicWrapper from "../../components/v2/layout/pageWrapper/BasicWrapper.vue";
import HeaderTitle from "../../components/v2/layout/header/HeaderTitle.vue";
import { useI18n } from "vue-i18n";
const { appContext } = getCurrentInstance()!;
const { t } = useI18n();
const clientStore = useClientStore();
const router = useRouter();
const route = useRoute();
const cookieConsentOpen = ref(false);
const isLoading = ref(true);

const userAuthenticator =
  appContext?.config.globalProperties.$userAuthenticator;

onMounted(async () => {
  try {
    await clientStore.getClient(null, route.params.slug as string);
    isLoading.value = false;
  } catch (err) {
    userAuthenticator?.logout();
    router.push({ name: "maintenancePage" });
  }
});
</script>
